import Vue from 'vue'
import VueRouter from 'vue-router'
import Landing from "../modules/landing/Landing.vue";
import Privacy from '../modules/terms/Privacy.vue';
import Service from '../modules/terms/Service.vue';
import Subscription from '../modules/terms/Subscription.vue';

export default new VueRouter({
  mode: "history",
  scrollBehavior: function(to, from, savedPosition) {
    if (to.hash) {
      return {
        selector: to.hash,
        el: to.hash,
        behavior: 'smooth',
      }
    } else {
      return { x: 0, y: 0 }
    }
  },
  routes: [
    {
      path: "/",
      component: Landing
    },
    {
      path: "/quiz",
      component: () => import("../modules/landing/QuizView.vue")
    },
    {
      path: "/email",
      component: () => import("../modules/email/Email.vue")
    },
    {
      path: "/subscription",
      component: () => import("../modules/paywall/AfterEmailPaywall.vue")
    },
    {
      path: "/subscriptions",
      component: () => import("../modules/payment/Payment.vue")
    },
    {
      path: "/privacy",
      component: Privacy,
    },
    {
      path: "/terms",
      component: Service,
    },
    {
      path: "/policy",
      component: Subscription,
    },
    {
      path: "/profile",
      component: () => import("../modules/profile/ProfileView.vue"),
      children: [
        {
          path: '',
          component: () => import("../modules/profile/views/Home.vue"),
        },
        {
          path: 'exercises',
          component: () => import("../modules/profile/views/Exercises.vue"),
        },
        {
          path: 'exercises/:id',
          component: () => import("../modules/profile/views/ExerciseView.vue"),
        },
        {
          path: 'articles',
          component: () => import("../modules/profile/views/Articles.vue"),
        },
        {
          path: 'meditations',
          component: () => import("../modules/profile/views/Meditations.vue"),
        },
        {
          path: 'account',
          component: () => import("../modules/profile/views/Account.vue"),
        },
        {
          path: 'kegel',
          component: () => import("../modules/profile/views/Kegel.vue"),
        },
        {
          path: 'kegel/:id',
          component: () => import("../modules/profile/views/KegelComplex.vue"),
        },
        {
          path: 'recipes',
          component: () => import("../modules/profile/views/Recipes.vue"),
        },
        {
          path: 'terms',
          component: () => import("../modules/profile/views/Terms.vue"),
        },
        {
          path: 'privacy-policy',
          component: () => import("../modules/profile/views/PrivacyPolicy.vue"),
        },
        {
          path: 'subscription-terms',
          component: () => import("../modules/profile/views/SubscriptionTerms.vue"),
        },
        {
          path: 'cookie-policy',
          component: () => import("../modules/profile/views/CookiePolicy.vue"),
        },
        {
          path: 'login',
          component: () => import("../modules/profile/views/Login.vue"),
        },
      ],
    },
  ],
})
